import React from 'react';

import Box from '../Box';
import { Wrapper } from "./ACommonStyles";
import { getPcsUrls } from "./AHelpers";

export default props => {
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);
	const isDesktop = window.innerWidth >= 996;

	return (
		<section className="container">
			<Wrapper className="row" pcs={pcs}>
				<div className="col-xs-12 col-md-6">
					{
						isDesktop ?
							<Box {...props} id="b1" type="BPhotoOnTop" settings={props.settings.b1} classes="" />
							:
							<Box {...props} id="b1" type="BPhotoOnLeft" settings={props.settings.b1} classes="" />
					}
				</div>
				<div className="col-xs-12 col-md-6">
					{
						isDesktop ?
							<Box {...props} id="b2" type="BPhotoOnTop" settings={props.settings.b2} classes="" />
							:
							<Box {...props} id="b2" type="BPhotoOnLeft" settings={props.settings.b2} classes="" />
					}
				</div>
			</Wrapper>
		</section>
	);
}
